import { InjectionToken } from '@angular/core';
import { Environment } from "../../model";

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
